import React, { PropsWithChildren, useMemo } from 'react'
import { useAtomValue } from 'jotai'
import {
  ConnectionProvider,
  WalletProvider
} from '@solana/wallet-adapter-react'
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui'

// import { rpcEndpointAtom } from '@/stores/settings'
import { rpcSettingAtom } from '@/stores/settings'

import { wallets } from '../adapters'
import SelectWalletModal from '../components/SelectWalletModal'

const SolanaProvider: React.FC<PropsWithChildren> = ({ children }) => {
  // const rpcEndpoint = useAtomValue(rpcEndpointAtom)
  const rpcSetting = useAtomValue(rpcSettingAtom)

  return (
    <ConnectionProvider endpoint={rpcSetting.rpcUrl}>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          {children}
          <SelectWalletModal />
        </WalletModalProvider>
      </WalletProvider>
    </ConnectionProvider>
  )
}

export default SolanaProvider
